<template>
    <relatorio-page :titulo=" 'Relatório do Lançamento Contábil' " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true" :fonteVariavel="true">
        
        <v-row>
            <v-col cols="12" md="12" class="font-weight-bold">
                Período do Lançamento Contábil: {{new Date(filtro.dataInicial).ddmmyyyy()}} até {{new Date(filtro.dataFinal).ddmmyyyy()}}
            </v-col>
        </v-row>

        <hr class="solid">
        
        <div v-if="filtro.listar === 'true'">
            
            <v-simple-table id="tabela" class="py-2 text-caption" dense>
                <template v-slot: default>
                    <thead style="background-color: #4A70A8">
                        <tr class="fonte">
                            <th style="font-size: 150% ; color: white; text-align: center; border-bottom:1px solid black" colspan="7">Transferências</th>
                        </tr>
                        <tr class="fonte">
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Data</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">CPF/CNPJ</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Descrição</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Banco</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Valor</th>
                            <th style="font-size: 100% ; color: white; text-align: center" colspan="2">Conta</th>
                        </tr>
                        <tr class="fonte">
                            <th style="font-size: 100% ; color: white; text-align: center">Crédito</th>
                            <th style="font-size: 100% ; color: white; text-align: center">Débito</th>
                        </tr>
                    </thead>
                    <tbody v-for="(itens, index) in item.transferencias" :key="index">
                        <tr class="fonte" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                            <td style="font-size: 100%">{{new Date(itens.data).ddmmyyyy()}}</td>
                            <td style="font-size: 100%">{{itens.cpfCnpj}}</td>
                            <td style="font-size: 100%">{{itens.descricao}}</td>
                            <td style="font-size: 100%">{{itens.banco}}</td>
                            <td class="text-right" style="font-size: 100%">{{itens.valor.toMoeda(true)}}</td>
                            <td style="font-size: 100%" rowspan="2">{{itens.credito}}</td>
                            <td style="font-size: 100%">{{itens.debito}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-simple-table id="tabela" class="py-2 text-caption" dense>
                <template v-slot: default>
                    <thead style="background-color: #4A70A8">
                        <tr class="fonte">
                            <th style="font-size: 150% ; color: white; text-align: center; border-bottom:1px solid black" colspan="7">Entradas / Saídas</th>
                        </tr>
                        <tr class="fonte">
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Data</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">CPF/CNPJ</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Descrição</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Banco</th>
                            <th style="font-size: 100% ; color: white; text-align: center" rowspan="2">Valor</th>
                            <th style="font-size: 100% ; color: white; text-align: center" colspan="2">Conta</th>
                        </tr>
                        <tr class="fonte">
                            <th style="font-size: 100% ; color: white">Crédito</th>
                            <th style="font-size: 100% ; color: white">Débito</th>
                        </tr>
                    </thead>
                    <tbody v-for="(itens, index) in item.entradasSaidas" :key="index">
                        <tr class="fonte" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                            <td style="font-size: 100%">{{new Date(itens.data).ddmmyyyy()}}</td>
                            <td style="font-size: 100%">{{itens.cpfCnpj}}</td>
                            <td style="font-size: 100%">{{itens.descricao}}</td>
                            <td style="font-size: 100%">{{itens.banco}}</td>
                            <td class="text-right" style="font-size: 100%">{{itens.valor.toMoeda(true)}}</td>
                            <td style="font-size: 100%" rowspan="2">{{itens.credito}}</td>
                            <td style="font-size: 100%">{{itens.debito}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

        </div>

        <div v-else>
            <v-simple-table id="tabela" class="py-2 text-caption" dense>
                <tbody v-for="item in item" :key="item.id">
                    <tr>
                        <td>
                            <v-simple-table dense>
                                <template v-slot: default>
                                    <thead style="background-color: #4A70A8">
                                        <tr class="fonte">
                                            <th class="text-left" style="font-size: 100% ; color: white">Data</th>
                                            <th style="font-size: 100% ; color: white">CPF/CNPJ</th>
                                            <th style="font-size: 100% ; color: white">Descrição</th>
                                            <th style="font-size: 100% ; color: white">Banco</th>
                                            <th class="text-right" style="font-size: 100% ; color: white">Valor</th>
                                        </tr>
                                    </thead>
                                    <tr>
                                        <td class="text-left font-weight-bold" style="font-size: 100%" colspan="5">{{ item.nome }}</td>
                                    </tr>
                                    <tbody v-for="(itens, index) in item.itens" :key="index">
                                        <tr class="fonte" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                            <td class="text-left" style="font-size: 100%;">{{new Date(itens.data).ddmmyyyy()}}</td>
                                            <td style="font-size: 100%">{{itens.cpfCnpj}}</td>
                                            <td style="font-size: 100%">{{itens.descricao}}</td>
                                            <td style="font-size: 100%">{{itens.banco}}</td>
                                            <td class="text-right" style="font-size: 100%">{{itens.valor.toMoeda(true)}}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-right font-weight-bold" style="font-size: 100%">TOTAL DA CONTA CONTÁBIL: {{item? item.total.toMoeda(true) : ""}}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';

export default {
    
    data: () => ({
        item:{},
        filtro:{

        },
        overlay: false
    }),
    props:{

    },
    mounted(){
        this.filtro = this.$route.query;
        this.Carregar();
    },
    methods:{
        Carregar(){
            const service = new FluxoBancarioService();
            this.overlay = true;
            service.Relatorio(this.filtro).then(
                res=>{
                    this.item = res.data;
                },
                err=>{
                    this.$swal('Aviso', err.response.data, 'error')
                }
            ).finally(() =>{
                this.overlay = false;
            })
        }
    }   

}
</script>

<style>

.fonte{
  font-size: 70%;
}

.cabecalhoDataTable{
    color: blue;
}

</style>
